module.exports = __webpack_public_path__ + "img/cbShtAbb.6c3d19ea.svg";